module.exports = __webpack_public_path__ + "static/img/10.61aff7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/10.jpg
// module id = 4pmG
// module chunks = 1